import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { getIsMobileTraffic } from 'selectors/shared/mobileTraffic'
import StudioLogo from 'svg/SA/studio-text-logo.svg'
import HamburgerIcon from 'svg/hamburger.svg'
import CloseIcon from 'svg/close-icon.svg'
import SALink from 'components/SALink'
import SaatchiLogo from 'svg/sa-header-logo.svg'
import SaatchiIconLogo from 'svg/saatchi-only-logo.svg'
import CollapseToggle from '../CollapseToggle/CollapseToggle'
import { getArtistProfileUrl } from '../helpers/selectors'
import styles from './Header.module.scss'

type HeaderProps = {
  fullName: string
  isMobileNavOpen: boolean
  onToggleMobileNav: () => void
  isDesktopCollapsed: boolean
  onToggleDesktopCollapse: () => void
}

const Header: FC<HeaderProps> = ({
  fullName,
  isMobileNavOpen,
  onToggleMobileNav,
  isDesktopCollapsed,
  onToggleDesktopCollapse,
}) => {
  const artistProfileUrl = useSelector(getArtistProfileUrl)
  const isMobileTraffic = useSelector(getIsMobileTraffic)
  return (
    <header className={styles.header}>
      <button
        type='button'
        className={styles.burger}
        onClick={onToggleMobileNav}
        aria-expanded={isMobileNavOpen}
        aria-label={isMobileNavOpen ? 'Close menu' : 'Open menu'}
      >
        {isMobileNavOpen ? (
          <CloseIcon className={styles.burgerIcon} />
        ) : (
          <HamburgerIcon className={styles.burgerIcon} />
        )}
      </button>
      <div className={styles.toggleAndLogo}>
        <CollapseToggle isCollapsed={isDesktopCollapsed} onToggle={onToggleDesktopCollapse} />
        <SALink
          className={styles.mobileSaLogoBox}
          alt='Saatchi Art logo'
          aria-label='Saatchi Art logo'
          data-type='logo'
          data-gtm-event='top-nav'
          href={process.env.SITE_URL || '/'}
        >
          {isMobileTraffic ? <SaatchiIconLogo /> : <SaatchiLogo />}
        </SALink>
      </div>
      <StudioLogo className={styles.logo} />

      <SALink href={artistProfileUrl} className={styles.userName}>
        {fullName}
      </SALink>
    </header>
  )
}

export default Header
